import { render, staticRenderFns } from "./freeDelivery.vue?vue&type=template&id=1cf256a7&scoped=true"
import script from "./freeDelivery.vue?vue&type=script&lang=js"
export * from "./freeDelivery.vue?vue&type=script&lang=js"
import style0 from "./freeDelivery.vue?vue&type=style&index=0&id=1cf256a7&lang=css"
import style1 from "./freeDelivery.vue?vue&type=style&index=1&id=1cf256a7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf256a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf256a7')) {
      api.createRecord('1cf256a7', component.options)
    } else {
      api.reload('1cf256a7', component.options)
    }
    module.hot.accept("./freeDelivery.vue?vue&type=template&id=1cf256a7&scoped=true", function () {
      api.rerender('1cf256a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/components/freeDelivery.vue"
export default component.exports